import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    getInstance(rootState, instanceId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La récupération de la grille d'audit utilisateur a échoué.",
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/user/instance/" + instanceId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getParentsTargetInstance(rootState, templateId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La récupération de la liste de sessions d'audit a échoué.",
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/template/" + templateId + "/parents-target-instance", {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getParentTargetInstance(rootState, parentTargetInstanceId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La récupération de la session d'audit a échoué.",
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/parent-target-instance/" + parentTargetInstanceId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    updateParentTargetInstance(rootState, parentTargetInstanceId, newParentTargetInstance, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La mise à jour de la session a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "report": newParentTargetInstance.report
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/parent-target-instance/" + parentTargetInstanceId + "/update", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};